import React, { useState, useEffect } from 'react';
import { tradingAPI } from '../../../../services/tradingAPI';

const POLITICIANS = [
  'Nancy Pelosi', 'Marjorie Taylor Greene', 'Tommy Tuberville',
  'Warren Davidson', 'Michael McCaul', 'Ro Khanna',
  'Dan Crenshaw', 'Dave McCormick', 'Mark Green',
  'Josh Gottheimer', 'Donald Norcross', 'Terri Sewell',
];

export default function CongressTrades() {
  const [trades,   setTrades]   = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);
  const [filter,   setFilter]   = useState('');

  useEffect(() => {
    fetchTrades();
  }, []);

  const fetchTrades = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await tradingAPI.getCongressTrades();
      setTrades(res.data?.trades || []);
    } catch (e) {
      setError('Unable to load congress trades right now.');
    } finally {
      setLoading(false);
    }
  };

  const filtered = filter
    ? trades.filter(t =>
        t.politician?.toLowerCase().includes(filter.toLowerCase()) ||
        t.ticker?.toLowerCase().includes(filter.toLowerCase())
      )
    : trades;

  return (
    <div style={s.wrap}>
      <div style={s.header}>
        <div>
          <h2 style={s.title}>🏛️ Congress Trades</h2>
          <p style={s.sub}>Tracking {POLITICIANS.length} top congressional traders</p>
        </div>
        <button style={s.refreshBtn} onClick={fetchTrades} disabled={loading}>
          {loading ? '⟳' : '↻ Refresh'}
        </button>
      </div>

      {/* Tracked politicians */}
      <div style={s.tagRow}>
        {POLITICIANS.map(p => (
          <span
            key={p}
            style={{ ...s.tag, background: filter === p ? '#764ba2' : 'rgba(118,75,162,0.15)' }}
            onClick={() => setFilter(filter === p ? '' : p)}
          >
            {p}
          </span>
        ))}
      </div>

      {/* Filter input */}
      <input
        style={s.search}
        placeholder="Filter by politician or ticker…"
        value={filter}
        onChange={e => setFilter(e.target.value)}
      />

      {/* Content */}
      {loading ? (
        <div style={s.center}>Loading trades…</div>
      ) : error ? (
        <div style={s.errorBox}>
          <p>{error}</p>
          <button style={s.refreshBtn} onClick={fetchTrades}>Try again</button>
        </div>
      ) : filtered.length === 0 ? (
        <div style={s.center}>
          {trades.length === 0
            ? 'No recent trades found. Capitol Trades may be temporarily unavailable.'
            : 'No trades match your filter.'}
        </div>
      ) : (
        <div style={s.tableWrap}>
          <table style={s.table}>
            <thead>
              <tr>
                {['Politician', 'Ticker', 'Type', 'Date', 'Amount'].map(h => (
                  <th key={h} style={s.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((t, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent' }}>
                  <td style={s.td}>{t.politician || '—'}</td>
                  <td style={{ ...s.td, color: '#a78bfa', fontWeight: 700 }}>{t.ticker || '—'}</td>
                  <td style={{ ...s.td, color: t.type?.toLowerCase().includes('buy') || t.type?.toLowerCase().includes('purchase') ? '#4ade80' : '#f87171' }}>
                    {t.type || '—'}
                  </td>
                  <td style={s.td}>{t.date || '—'}</td>
                  <td style={s.td}>{t.amount || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p style={s.disclaimer}>
        Data sourced from Capitol Trades. Trades are disclosed per STOCK Act requirements (within 45 days). Not financial advice.
      </p>
    </div>
  );
}

const s = {
  wrap:        { padding: '24px', color: '#e2e8f0', fontFamily: 'inherit' },
  header:      { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
  title:       { margin: 0, fontSize: 22, fontWeight: 700 },
  sub:         { margin: '4px 0 0', fontSize: 13, color: '#94a3b8' },
  refreshBtn:  { background: 'rgba(118,75,162,0.3)', color: '#c4b5fd', border: '1px solid rgba(167,139,250,0.3)', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 13 },
  tagRow:      { display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 },
  tag:         { padding: '4px 10px', borderRadius: 20, fontSize: 12, color: '#c4b5fd', cursor: 'pointer', transition: 'background 0.15s' },
  search:      { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 10, color: '#e2e8f0', fontSize: 14, marginBottom: 20, outline: 'none', boxSizing: 'border-box' },
  center:      { textAlign: 'center', color: '#94a3b8', padding: '40px 0', fontSize: 14 },
  errorBox:    { textAlign: 'center', color: '#f87171', padding: '30px 0' },
  tableWrap:   { overflowX: 'auto', borderRadius: 10, border: '1px solid rgba(255,255,255,0.08)' },
  table:       { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th:          { padding: '12px 16px', textAlign: 'left', color: '#94a3b8', fontWeight: 600, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid rgba(255,255,255,0.08)' },
  td:          { padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.05)' },
  disclaimer:  { marginTop: 20, fontSize: 11, color: '#64748b', textAlign: 'center' },
};
